import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import SrStepper from 'client/components/SrStepper';

const rentalAplicationSteps = [
  {
    title: 'Agree',
  },
  {
    title: 'Credit',
  },
  {
    title: 'Pay',
  },
  {
    title: 'Form',
  },
];

const SrRentalApplicationFlowStepHeader = ({
  activeStep,
  hideBackButton,
  onSaveAndExit,
  isGuarantorApp,
}) => (
  <div className='header'>
    <div className='headerWrapper'>
      <div className='navbarRentalApplication'>
        <div className='navbarTitleWrapper'>
          <SrText weight='bold' font='whitney-sc'>
            {isGuarantorApp
              ? 'guarantor '
              : 'renter '
            }
            app
          </SrText>
        </div>
        {!hideBackButton && (
          <SrLink to='/profile' redirectToLastLocation className='backButton' />
        )}
        {onSaveAndExit && (
          <SrText weight='medium' cursor='pointer' onClick={onSaveAndExit} className='saveAndExit'>
            Save & Exit
          </SrText>
        )}
      </div>
      <div className='stepperWrapper'>
        <SrStepper steps={rentalAplicationSteps} activeStep={activeStep} />
      </div>
    </div>
  </div>
);

SrRentalApplicationFlowStepHeader.propTypes = {
  activeStep: PropTypes.number,
  hideBackButton: PropTypes.bool,
  onSaveAndExit: PropTypes.func,
};

SrRentalApplicationFlowStepHeader.defaultProps = {
  hideBackButton: false,
};

SrRentalApplicationFlowStepHeader.displayName = 'SrRentalApplicationFlowStepHeader';

export default SrRentalApplicationFlowStepHeader;
